import React, { Fragment } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import { pictureUrl } from './common/pictureUrl'
import { useSelector } from 'react-redux'
import { Container, Hidden, Typography, useMediaQuery, Grid, Box, makeStyles, Button } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { Trans } from 'react-i18next'
import { Hero } from '../pages/hire-developer'
import i18n from './i18n/i18n'

export const Banner = ({ countryCode }) => (
  <Fragment>
    <Hero countryCode={countryCode} />
    <NewsCarousel />
  </Fragment>
)

const useStyles = makeStyles({
  carousel: {
    direction: 'initial'
  },
  highlights: {
    position: 'absolute',
    top: '-25px',
    left: '40%',
    right: '40%',
    whiteSpace: 'nowrap',
    backgroundColor: '#413E52',
    fontWeight: 'bold',
    color: 'white',
    padding: '5px',
    textAlign: 'center',
    zIndex: 1000,
    lineHeight: '40px',
    textTransform: 'uppercase'
  }
})

const NewsCarousel = () => {
  const articles = useSelector((state) => state.articles)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const dimensions = isMobile ? [600, 350] : [1232, 310]

  const classes = useStyles()

  if (!articles) return null

  return (
    <div style={{ position: 'relative', marginTop: '30px' }} className="homepage-banner">
      <span className={classes.highlights}>
        <Trans i18nKey="banner.featured" />
      </span>
      <Carousel infiniteLoop centerMode autoPlay showThumbs={false} className={classes.carousel}>
        {Object.values(articles)
          .reverse()
          .map((article) => (
            <a href={`/${i18n.language}/news/${article.hashid}`}>
              <div key={article.id}>
                <img
                  src={pictureUrl(
                    {
                      record_id: article.id,
                      record_type: 'Blog::Article',
                      name: 'picture',
                      created_at: article.picture?.record?.created_at
                    },
                    ...dimensions,
                    'Project picture image',
                    'resize_to_fill'
                  )}
                  alt="article_image"
                />
                <p className="legend">{article.title}</p>
              </div>
            </a>
          ))}
      </Carousel>
    </div>
  )
}